import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './base-query';

const syllabusAPI = createApi({
  reducerPath: 'syllabusAPI',
  baseQuery,
  tagTypes: ['syllabus'],
  endpoints: (builder) => ({
    getSyllabus: builder.query({
      query: (params) => {
        const queryParams = {
          page: params?.page ?? 1,
          size: params?.size ?? 10,
        };

        if (params?.search && typeof params.search === 'string' && params.search.trim()) {
          queryParams.search = params.search.trim();
        }

        return {
          url: '/api/v1/admin/syllabus',
          method: 'GET',
          params: queryParams,
        };
      },
      providesTags: ['syllabus'],
    }),

    getChapterById: builder.query({
      query: (chapterId) => ({
        url: `/api/v1/admin/syllabus/${chapterId}`,
        method: 'GET',
      }),
      providesTags: (result, error, chapterId) => [{ type: 'syllabus', id: chapterId }],
    }),

    createChapter: builder.mutation({
      query: (payload) => ({
        url: '/api/v1/admin/syllabus',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['syllabus'],
    }),

    updateChapter: builder.mutation({
      query: ({ chapterId, payload }) => ({
        url: `/api/v1/admin/syllabus/${chapterId}`,
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: (result, error, { chapterId }) => [
        'syllabus',
        { type: 'syllabus', id: chapterId },
      ],
    }),

    deleteChapter: builder.mutation({
      query: (chapterId) => {
        const id = typeof chapterId === 'object' && chapterId !== null
          ? (chapterId?.chapterId || chapterId?.id)
          : chapterId;
        return {
          url: `/api/v1/admin/syllabus/${id || ''}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: (result, error, arg) => {
        const id = typeof arg === 'object' && arg !== null
          ? (arg?.chapterId || arg?.id)
          : arg;
        return [
          'syllabus',
          ...(id ? [{ type: 'syllabus', id }] : []),
        ];
      },
    }),

    updateChapterOrder: builder.mutation({
      query: (payload) => ({
        url: '/api/v1/admin/syllabus/chapters/order',
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['syllabus'],
    }),

    updateSubtopicOrder: builder.mutation({
      query: ({ chapterId, payload }) => ({
        url: `/api/v1/admin/syllabus/subtopics/order/${chapterId}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: (result, error, { chapterId }) => [
        'syllabus',
        { type: 'syllabus', id: chapterId },
      ],
    }),
  }),
});

export const {
  useGetSyllabusQuery,
  useGetChapterByIdQuery,
  useCreateChapterMutation,
  useUpdateChapterMutation,
  useDeleteChapterMutation,
  useUpdateChapterOrderMutation,
  useUpdateSubtopicOrderMutation,
} = syllabusAPI;

export default syllabusAPI;
